import BaseServiceCrud from './BaseServiceCrud';

export default class AdditionalToolsService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'additional-tools';
    }


    highwayEnable(value) {
        let url = '';
        if(value === true){
            url = `${this.domain}/${this.path}/highway-enable`;
        } else {
            url = `${this.domain}/${this.path}/highway-disable`;
        }
        return this.fetch(url, {
            method: 'POST'
        });
    }

    getHighwayPaymentInfo() {
        return this.fetch(`${this.domain}/${this.path}/highway-payments`, {
            method: 'GET',
        }).catch((err) => {
            throw err;
        });
    }

    getHighwayAllTerms() {
        return this.fetch(`${this.domain}/${this.path}/highway-payments/terms`, {
            method: 'GET',
        }).catch((err) => {
            throw err;
        });
    }

    highwayCardAction(request) {
        let url = `${this.domain}/${this.path}/highway-card-action`;
   
        return this.fetch(url, {
            method: 'POST',
            body: JSON.stringify(request),
        });
    }



}
